"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genCancelToken = void 0;
var axios_1 = __importDefault(require("axios"));
function genCancelToken() {
    var token = axios_1.default.CancelToken.source();
    token.id = "_" + Math.random().toString(36).substr(2, 9);
    return token;
}
exports.genCancelToken = genCancelToken;
//# sourceMappingURL=axiosHelper.js.map